import React from "react";

// Componente para el contenido de las pestañas
function TabPanel(props) {
  const { children, value, index, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      // ✅ SOLUCIÓN DEFINITIVA: Usar maxHeight y overflow en lugar de display/position
      // Los campos SIEMPRE están en el flujo del documento normal para que Formik los capture
      style={{ 
        display: 'block', // ✅ SIEMPRE block
        maxHeight: value !== index ? '0' : 'none', // ✅ Colapsar altura cuando está oculto
        overflow: value !== index ? 'hidden' : 'visible', // ✅ Ocultar overflow
        opacity: value !== index ? 0 : 1, // ✅ Ocultar visualmente
        pointerEvents: value !== index ? 'none' : 'auto', // ✅ Desactivar interacción cuando está oculto
        transition: 'opacity 0.2s ease-in-out' // ✅ Transición suave
      }}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={className}
      {...other}
    >
      {/* Renderizar siempre los hijos - Formik captura los valores porque están en el flujo normal */}
      {children}
    </div>
  );
}

export default TabPanel;
